import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: { main: "#8338ec" },
    secondary: { main: "#ff006e" },
    background: {
      default: "#f5f5f5",
      paper: "#ffffff",
      paperColored: "#fef6e9",
      paperDark: "#333333",
    },
    text: {
      primary: "#333333",
      secondary: "#555555",
    },
    error: { main: "#f44336" },
    warning: { main: "#ff9800" },
    success: { main: "#4caf50" },
    info: { main: "#579adc" },
  },
  typography: {
    fontFamily: "'Raleway', sans-serif",
    h1: { fontSize: "2.5rem", fontWeight: 700 },
    h2: { fontSize: "2rem", fontWeight: 600 },
    body1: { fontSize: "1rem", fontWeight: 400 },
    button: { textTransform: "none" },
  },
  shape: {
    borderRadius: 3,
  },
  spacing: 8,
});

export default theme;
